/**
 * Find Your Solution — bundle cards slider (theme editor safe).
 */
(function () {
  class FindYourSolutionSlider extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.destroySwiper();
    }

    destroySwiper() {
      if (this.swiperInstance && this.swiperInstance.destroy) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
      this.classList.remove('is-overflow-visible');
    }

    updateOverflowState() {
      const swiper = this.swiperInstance;
      if (!swiper) return;

      const slidesPerView = swiper.params.slidesPerView;
      const isFourSlidesView = slidesPerView === 4;
      this.classList.toggle('is-overflow-visible', !isFourSlidesView);
    }

    init() {
      const container = this.querySelector('.section-find-your-solution__swiper');
      if (!container || typeof Swiper === 'undefined') return;

      this.destroySwiper();

      const sectionId = this.getAttribute('data-section-id');
      const paginationEl = this.querySelector(`.${sectionId}-pagination`);

      this.swiperInstance = new Swiper(container, {
        direction: 'horizontal',
        slidesPerView: 4,
        spaceBetween: 20,
        speed: 500,
        loop: false,
        watchOverflow: true,
        pagination: paginationEl
          ? {
            el: paginationEl,
            clickable: true
          }
          : false,
        breakpoints: {
          0: {
            slidesPerView: 1.15,
            spaceBetween: 12
          },
          577: {
            slidesPerView: 2,
            spaceBetween: 15
          },
          767: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20
          }
        },
        a11y: {
          prevSlideMessage: 'Previous bundle',
          nextSlideMessage: 'Next bundle',
          paginationBulletMessage: 'Go to bundle slide {{index}}'
        },
        on: {
          init: () => this.updateOverflowState(),
          breakpoint: () => this.updateOverflowState(),
          resize: () => this.updateOverflowState()
        }
      });

      this.updateOverflowState();
    }
  }

  if (!customElements.get('find-your-solution-slider')) {
    document.addEventListener('DOMContentLoaded', () => {
      customElements.define('find-your-solution-slider', FindYourSolutionSlider);
    })
  }
})();